import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { BalanceState } from "./type";

const INITIAL_STATE: BalanceState = {
  balance: null,
  lastProcessedStore: null,
};

const balanceSlice = createSlice({
  name: "balance",
  initialState: INITIAL_STATE,
  reducers: {
    setBalance(state, action: PayloadAction<BalanceState["balance"]>) {
      state.balance = action.payload;
    },
    setLastProcessedStore(state, action: PayloadAction<string | null>) {
      state.lastProcessedStore = action.payload;
    },
    clearBalance(state) {
      state.balance = null;
      state.lastProcessedStore = null;
    },
  },
});

export const { setBalance, setLastProcessedStore, clearBalance } = balanceSlice.actions;
export default balanceSlice.reducer;